import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'

interface SelectTypeProps {
  type: string
  onChange: (event: SelectChangeEvent<string>) => void
}

const creditTypes = [
  { value: '', label: 'All Types' },
  { value: 'credit', label: 'Weekly Loss Credit' },
  { value: 'nft_bonus', label: 'Daily NFT Bonus' },
  { value: 'nft_credit', label: 'Weekly NFT Credit' },
]

const SelectType: React.FC<React.PropsWithChildren<SelectTypeProps>> = ({ type, onChange }) => {
  return (
    <FormControl size="small" sx={{ minWidth: 200, marginLeft: 'auto' }}>
      <InputLabel id="type-select-label">Type</InputLabel>
      <Select
        labelId="type-select-label"
        id="type-select"
        value={type}
        label="Type"
        onChange={onChange}
      >
        {creditTypes.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SelectType